'use strict';

var _class, _temp2;

var _image = require('../Image/image');

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PropTypes = require('prop-types');
var React = require('react');

var BagButton = require('../bagbutton.js');

module.exports = (_temp2 = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            addedToBag: false
        }, _this.addToBagHandler = function () {
            if (_this.props.addToBagHandler && !_this.state.addedToBag) {
                _this.props.addToBagHandler(_this.props.item.cartItems);
            }
            _this.setState({ addedToBag: true });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _class.prototype.render = function render() {
        var menuItemClass = 'menu-item favorite';
        var textClass = 'text favorite';
        var topLevelClass = 'col-md-4 col-sm-4 col-xs-12 top-bottom-margin favorite';
        var imgSrc = this.props.isMeal ? '/images/common/img_fav_placeholder.png' : this.props.imgUrl;
        var buttonClass = this.state.addedToBag ? 'btn btn-primary btn-disabled' : 'btn btn-primary';

        return React.createElement(
            'div',
            { className: topLevelClass },
            React.createElement(
                'button',
                { className: 'menu-item-container', onClick: this.addToBagHandler, disabled: this.state.addedToBag },
                React.createElement(
                    'div',
                    { className: menuItemClass },
                    React.createElement(
                        'div',
                        { className: 'image' },
                        React.createElement(
                            'div',
                            { className: this.props.isMeal ? 'number-of-items' : 'hidden' },
                            React.createElement(
                                'div',
                                { className: 'quantity' },
                                this.props.totalQuantity
                            )
                        ),
                        React.createElement(_image2.default, { backupImage: this.props.backupImage, src: imgSrc, id: this.props.itemid + '-img' })
                    ),
                    React.createElement(
                        'div',
                        { className: textClass },
                        React.createElement(
                            'div',
                            { id: this.props.itemid + '-label', className: 'menu-item-name text-center' },
                            this.props.name
                        ),
                        React.createElement(
                            'div',
                            { className: 'products-text' },
                            this.props.productNames
                        )
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'add-button' },
                    React.createElement(BagButton, {
                        buttonClass: buttonClass,
                        inEditMode: this.state.addedToBag,
                        text: this.props.addToBagText,
                        clickedText: this.props.addedToBagText })
                )
            )
        );
    };

    return _class;
}(React.Component), _class.propTypes = {
    itemid: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    imgUrl: PropTypes.string.isRequired,
    onClickHandler: PropTypes.func.isRequired,
    backupImage: PropTypes.string.isRequired
}, _temp2);


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/menu/menuItem.js
// module id = 828
// module chunks = 0